<template>
    <div>
        <div class="content-box account-info first">
            <el-form :model="formData" class="sr-from-single" ref="formData" label-width="150px">
                <el-form-item
                    label="新手机号"
                    :rules="[
                        {required: true, message: '请输入新手机号'},
                        {regexp: /^\d{11}$/, message: '请输入正确的手机号码'},
                    ]"
                >
                    <el-input placeholder="手机号码" min="11" max="11" v-model="formData.telephone"></el-input>
                </el-form-item>
                <el-form-item label="验证码" :rules="[{required: true, message: '请输短信验证码'}]">
                    <el-input placeholder="请输入短信验证码" v-model="formData.verificationCode"></el-input>
                    <el-button @click="sendSms" :disabled="smsTime == 0 ? false : true" class="underline sms-code" type="text">
                        {{ smsTime === 0 ? '点击获取' : `（${smsTime}S）` }}
                    </el-button>
                </el-form-item>
                <div class="item" v-if="errorMessage">
                    <label></label>
                    <div class="error">
                        <template v-if="threeElementsFail">
                            该手机号无法完成实名认证
                            <br />
                            {{ errorMessage }}
                            <br />
                            尝试
                            <span class="important" @click="displayQrCode()">人脸识别</span>
                            进行实名认证
                        </template>
                        <template v-else>
                            {{ errorMessage }}
                        </template>
                    </div>
                </div>
            </el-form>
            <div style="text-align: center">
                <el-button @click="onColse">取 消</el-button>
                <el-button type="primary" :loading="nextLoading" @click="sendPhone">下一步</el-button>
            </div>
        </div>
        <el-dialog
            title="人脸识别认证"
            :visible.sync="weixinVisible"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            width="450px"
        >
            <div class="qr-content">
                <p>
                    将要为
                    <b>({{ formData.telephone }})</b>
                    进行人脸识别
                    <br />
                    请使用微信扫一扫在手机完成认证
                </p>
                <div class="qrcode" ref="qrCode"></div>
            </div>
            <div slot="footer" class="qr-footer">
                <el-button type="primary" :loading="successLoading" icon="el-icon-success">认证中</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        phone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            formData: {
                telephone: '', // 新手机号
                verificationCode: '', // 短信验证码
            },
            smsTime: 0,
            serialNumber: '',
            errorMessage: '', // 错误的文字描述
            nextLoading: false,
            qrcode: null,
            threeElementsFail: false, // 三要素认证失败
            weixinVisible: false,
            successLoading: false,
        };
    },
    computed: {
        qrUrl() {
            const {sign, config} = this.$store.state;
            return `${config.cpHomeUrl}/pages/contract/vefify/dzq/aliveVideo/aliveEditPhone?sign=${sign}&from=pc`;
        },
    },
    // mounted() {
    //     this.$dzqToFdd();
    // },
    methods: {
        displayQrCode() {
            this.weixinVisible = true;
            this.$nextTick(() => {
                this.creatQrCode();
                this.getStatus();
            });
        },
        // 获取认证状态
        async getStatus() {
            this.successLoading = true;
            const response = await this.$request({
                url: '/org/get/edit/telephone/stage',
                method: 'get',
            });
            const {state, result, msg} = response.data;
            if (!state) return this.$message.error(msg || '');
            if (result != 3) {
                await new Promise((resolve) => setTimeout(resolve, 4000));
                this.getStatus();
            } else {
                // 修改成功
                this.$message.success('手机号修改成功');
                this.$emit('onSuccess', true);
                this.weixinVisible = false;
                this.successLoading = false;
            }
        },
        creatQrCode() {
            if (this.qrcode) {
                this.qrcode.makeCode(this.qrUrl);
            } else {
                this.qrcode = new QRCode(this.$refs.qrCode, {
                    text: this.qrUrl,
                    width: 150,
                    height: 150,
                    colorDark: '#5914ee',
                    colorLight: '#ffffff',
                    correctLevel: 3,
                });
            }
        },
        onColse() {
            this.$router.go(-1);
        },
        async sendSms() {
            const {telephone} = this.formData;
            if (this.smsTime > 0) return;
            if (!telephone || !/^\d{11}$/.test(telephone)) return this.$message.error('请输入正确的手机号');
            const response = await this.$request({
                url: '/code/add/login/sms',
                method: 'post',
                params: {
                    telephone,
                },
            });
            const {msg, state} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.smsTime = 60;
            const smsInterval = setInterval(() => {
                this.smsTime -= 1;
                if (this.smsTime <= 0) clearInterval(smsInterval);
            }, 1000);
        },
        async sendPhone() {
            this.$refs['formData'].validate(async (valid) => {
                if (!valid) return;
                const {telephone, verificationCode} = this.formData;
                if (!telephone || !/^\d{11}$/.test(telephone)) return this.$message.error('请输入正确的手机号');
                if (!verificationCode) return this.$message.error('请输入短信验证码');
                await this.$dzqToFddNew(1, telephone);
                // this.errorMessage = '';
                // this.nextLoading = true;
                // const response = await this.$request({
                //     url: '/org/edit/telephone',
                //     method: 'post',
                //     data: {
                //         telephone,
                //         verificationCode,
                //     },
                // });
                // const {msg, state, code} = response.data;
                // this.nextLoading = false;

                // if (!state) {
                //     if (code == 11006) this.threeElementsFail = true;
                //     this.errorMessage = msg;
                // } else {
                //     this.$message.success('手机号修改成功');
                //     await this.$store.dispatch('getUserInfo');
                //     this.onColse();
                // }
            });
        },
    },
};
</script>
<style lang="scss">
.update-phone-dialog {
    .el-dialog__body {
        padding: 0px 60px;

        .item {
            display: block;

            label {
                color: $--color-font-normal;
            }
        }
    }
}

.form-body {
    .el-form-item__label {
        text-align: left;
    }

    .underline {
        position: absolute;
        right: 10px;
        top: 10px;
        font-weight: bold;
    }

    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 80px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }

        .el-button {
            padding: 10px 20px;
        }

        .error {
            color: $--color-font-error;
        }
    }
}

.qr-content {
    text-align: center;

    b {
        color: #333;
    }

    .qrcode {
        margin-top: 20px;
        text-align: center;
        display: inline-block;
    }
}
</style>
